<template>
  <v-autocomplete v-model="MapSearch_Suggest_model" class="mb-3 mx-4" :items="MapSearch_Suggest_items"
    :loading="MapSearch_Suggest_isLoading" :search-input.sync="MapSearch_Suggest_search" hide-details="true"
    hide-no-data item-text="text" item-value="magicKey" label="Vyhledat místo" prepend-icon="mdi-map-search" clearable
    hide-selected return-object :filter="MapSearch_Filter">
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.text"></v-list-item-title>
        <v-list-item-subtitle v-text="item.type.split(/(?=[A-Z])/).join(' ')"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    // webová služba
    ServiceCuzkRuianGeocode: null,
    // // Zoom podle Mbr
    // MapViewZoomToMbr: null,
  },

  data() {
    return {
      // Vybraná položka
      MapSearch_Suggest_model: null,
      // Seznam položek
      MapSearch_Suggest_items: [],
      // Načítám z webu
      MapSearch_Suggest_isLoading: false,
      // hledám
      MapSearch_Suggest_search: null,
    };
  },

  watch: {
    // Hledat výraz - suggest
    MapSearch_Suggest_search(value) {
      this.MapSearch_Suggest_isLoading = true;

      this.ServiceCuzkRuianGeocode.Suggest(value)
        .then((response) => {
          this.MapSearch_Suggest_items = response.data.suggestions;
          this.MapSearch_Suggest_isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.MapSearch_Suggest_items = [];
          this.MapSearch_Suggest_isLoading = false;
        })
        .then(function () {
          // always executed
        });
    },

    // Výběr položky - find a zoom
    MapSearch_Suggest_model(value) {
      if (value !== null && typeof value !== "undefined") {
        // console.log("MapSearch_Suggest_model");
        // console.log(value);

        this.ServiceCuzkRuianGeocode.Find(value.text, value.magicKey)
          .then((response) => {
            // console.log(response.data);

            if (response.data.locations[0].feature.attributes.Type == "ParcelaDefinicniBod") {
              // Definiční bod - zoom na bod a měřítko

              // console.log("ParcelaDefinicniBod");
              // console.log(response.data.locations[0])
              this.MapViewZoomToScalePointXY(1/1000, { x: response.data.locations[0].feature.geometry.x, y: response.data.locations[0].feature.geometry.y })

            } else {
              // Ostatní - zoom na bbox


              var xmin, ymin, xmax, ymax;
              var rmin = 0.003;
              // Když jsou podobné souřadnice
              xmin = response.data.locations[0].extent.xmin;
              ymin = response.data.locations[0].extent.ymin;
              xmax = response.data.locations[0].extent.xmax;
              ymax = response.data.locations[0].extent.ymax;

              if (
                Math.round(xmin * 1000) / 1000 ==
                Math.round(xmax * 1000) / 1000
              ) {
                xmin -= rmin;
                xmax += rmin;
              }

              if (
                Math.round(ymin * 1000) / 1000 ==
                Math.round(ymax * 1000) / 1000
              ) {
                ymin -= rmin;
                ymax += rmin;
              }

              this.MapViewZoomToMbr({
                epsg: "EPSG:3857",
                xmin: xmin,
                ymin: ymin,
                xmax: xmax,
                ymax: ymax,
              });


            }

          })
          .catch((error) => {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
      }
    },
  },

  methods: {
    // Změna mapového výřezu podle obdelníku
    MapViewZoomToMbr: function (value) {
      this.$emit('MapViewZoomToMbr', value);
    },

    // Změna mapového výřezu na cílové měřítko - volá se funkce v nadřazeném objektu
    MapViewZoomToScalePointXY: function (vTargetScale, vLocation) {
      this.$emit('MapViewZoomToScalePointXY', vTargetScale, vLocation);
    },

    // Filtrování položek
    MapSearch_Filter: function (item, queryText, itemText) {
      // výchozí je následující funkce
      itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
      // Jenže pak se nezobrazí položky, které mají jiný text
      // např. když pošlu na vyhledávač Mapy.cz
      // '50.2233361N 14.8512964E' vyhledá se '50°13'24.01"N 14°51'4.667"E
      // jenže ten se pak přes tento filtr nedostane, má jiný text
      // pro vyhledávání na MapyCz nás vlastně tento filtr nezajímá, chceme zobrazit vše, co jejich fukce vrátí
      // Uvedené platilo pro MapyCz, ale i pro CUZK se prostě zobrazí vše, co se vrátí, nic se nefiltruje.
      return true;
    },
  },
};
</script>

<style></style>